import './tab-card.css';

import { IconButton } from 'bz-core-controls/controls/next/menu';

import React from 'react';

const TabCard = ({ className, header, children, pad = true }) => {
  if (!React.isValidElement(header)) {
    header = <TabCardHeader title={header} />;
  }
  return (
    <div className={`tab-card ${pad ? '' : 'no-padding'} ${className}`}>
      {header}
      <div className="tab-card-content">{children}</div>
    </div>
  );
};

const TabCardHeader = ({ className, title, func, navIcon, colour, navButton }) => {
  let navigator = <span />;

  if (func != null && navIcon != null) {
    navigator = (
      <IconButton
        onClick={func}
        style={{ float: 'right', width: 36, marginTop: -16, marginRight: 0 }}
        iconStyle={{ stroke: 'white' }}
      >
        {navIcon}
      </IconButton>
    );
  } else if (navButton != null) {
    navigator = navButton;
  }

  return (
    <div className={`tab-card-header ${className}`} style={{ borderLeft: `10px solid ${colour}` }}>
      {title}
      {navigator}
    </div>
  );
};

export { TabCard, TabCardHeader };
